import { ALGOLIA_FACETS } from "@/modules/jobAds/client/constants"

export const getAlgoliaPublicationDateFilter = (publicationDate: string): string[] => {
  const date = new Date()

  switch (publicationDate) {
    case "last-month":
      return [`${ALGOLIA_FACETS.PUBLICATION_DATE} > ${Math.floor(date.setMonth(date.getMonth() - 1) / 1000)}`]
    case "last-week":
      return [`${ALGOLIA_FACETS.PUBLICATION_DATE} > ${Math.floor(date.setDate(date.getDate() - 7) / 1000)}`]
    case "last-48-hours":
      return [`${ALGOLIA_FACETS.PUBLICATION_DATE} > ${Math.floor(date.setDate(date.getDate() - 2) / 1000)}`]
    case "last-24-hours":
      return [`${ALGOLIA_FACETS.PUBLICATION_DATE} > ${Math.floor(date.setDate(date.getDate() - 1) / 1000)}`]
    default:
      // fire the empty state in the search page
      return [`${ALGOLIA_FACETS.PUBLICATION_DATE} < 0`]
  }
}
